import { testimonials } from "@/mocks/comics";

export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 bg-background-200/70">
      <div className="container-page">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-secondary-600 bg-secondary-100 px-3 py-1 rounded-full mb-4">
            <i className="ri-chat-heart-line"></i> 读者口碑
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            听听 <span className="text-primary-500">读者们</span> 怎么说
          </h2>
          <p className="mt-3 text-foreground-500 text-sm max-w-lg mx-auto">
            来自真实读者的评价，这是我们不断进步的动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t, index) => {
            if (index === 0) {
              return (
                <div key={t.id} className="md:col-span-2 bg-background-50 rounded-xl p-6 md:p-8 flex flex-col">
                  <div className="flex items-center gap-3 mb-4">
                    <img src={t.avatar} alt={t.name} className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover" />
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                  <div className="flex gap-0.5 mb-3">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                    ))}
                  </div>
                  <i className="ri-double-quotes-l text-3xl text-primary-200 mb-2"></i>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed flex-1">{t.comment}</p>
                </div>
              );
            }

            return (
              <div key={t.id} className="bg-background-50 rounded-xl p-5 md:p-6 flex flex-col">
                <div className="flex items-center gap-3 mb-3">
                  <img src={t.avatar} alt={t.name} className="w-9 h-9 md:w-10 md:h-10 rounded-full object-cover" />
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </div>
                <div className="flex gap-0.5 mb-2">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>
                  ))}
                </div>
                <i className="ri-double-quotes-l text-2xl text-primary-200 mb-2"></i>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">{t.comment}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}